const ADMIN_SESSION_NOTICE_KEY = 'alu_admin_session_notice';

const REASON_CONTENT = {
  another_user_logged_in: {
    title: 'Session Ended',
    message: 'Your admin session ended because your account was signed in on another device or browser.',
  },
  inactivity_timeout: {
    title: 'Session Timed Out',
    message: 'Your session ended due to inactivity. Please sign in again to continue.',
  },
  manual_end_session: {
    title: 'Session Ended',
    message: 'Your session was ended manually via End Session or Logout.',
  },
  invalid_or_expired_token: {
    title: 'Session Expired',
    message: 'Your token is invalid or expired. Please sign in again.',
  },
  environment_changed: {
    title: 'Session Ended',
    message: 'Your session ended because the client environment changed.',
  },
  ip_changed: {
    title: 'Session Ended',
    message: 'Your session ended because the IP address changed.',
  },
  unknown: {
    title: 'Session Ended',
    message: 'Your admin session has ended. Please sign in again.',
  },
};

const normalizeText = (value) => String(value ?? '').trim().toLowerCase();

export const resolveAdminSessionEndReason = (message) => {
  const normalized = normalizeText(message);
  if (!normalized) return 'unknown';

  if (normalized.includes('timed out due to inactivity') || normalized.includes('inactivity')) {
    return 'inactivity_timeout';
  }
  if (normalized.includes('invalid or expired token') || normalized.includes('invalid token') || normalized.includes('token payload')) {
    return 'invalid_or_expired_token';
  }
  if (normalized.includes('ip change')) {
    return 'ip_changed';
  }
  if (normalized.includes('environment change')) {
    return 'environment_changed';
  }
  if (normalized.includes('session expired or terminated') || normalized.includes('session expired') || normalized.includes('session invalidated')) {
    return 'another_user_logged_in';
  }

  return 'unknown';
};

export const setAdminSessionNotice = ({ reason, backendMessage = '' } = {}) => {
  if (typeof window === 'undefined') return;
  const resolvedReason = reason || resolveAdminSessionEndReason(backendMessage);
  const payload = {
    reason: resolvedReason,
    backendMessage: String(backendMessage ?? ''),
    createdAt: Date.now(),
  };
  window.localStorage.setItem(ADMIN_SESSION_NOTICE_KEY, JSON.stringify(payload));
};

export const consumeAdminSessionNotice = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(ADMIN_SESSION_NOTICE_KEY);
    if (!raw) return null;
    window.localStorage.removeItem(ADMIN_SESSION_NOTICE_KEY);
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const reason = String(parsed.reason || 'unknown');
    return {
      reason,
      backendMessage: String(parsed.backendMessage || ''),
      createdAt: Number(parsed.createdAt || Date.now()),
    };
  } catch {
    window.localStorage.removeItem(ADMIN_SESSION_NOTICE_KEY);
    return null;
  }
};

export const getAdminSessionNoticeCopy = (reason, backendMessage = '') => {
  const base = REASON_CONTENT[reason] || REASON_CONTENT.unknown;
  if (!backendMessage) return base;
  return {
    title: base.title,
    message: `${base.message}\n\nDetails: ${backendMessage}`,
  };
};
